import React, { FC } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../store/AppContext';

type Props = {
  vale: {
    tipoLista: number;
    numOferta: string;
    fechaIniVigencia: any;
    fechaFinVigencia: string;
    fechaFinCanjeoDTO: string;
    fechaFinActivacion: string;
    fechaFinCanjeoPromo: string;
    visualizar: boolean;
    activable: boolean;
    gupoInternoVisualizar: string;
    grupoInternoActivacion: string;
    valeEAN: string;
    exclusividad: boolean;
    entregada: boolean;
    canjeada: boolean;
    activada: boolean;
    idioma: string;
    textoReclamo: string;
    textoTitulo: string;
    textoDescripcion1: string;
    textoDescripcion2: string;
    canalActivacion: string;
    canales: object;
    fechaActivacion: string;
    tipoVale: string;
    scoring: number;
    codImpacto: number;
    planAdhesion: number;
    denominacionPlanAdhesion: string;
    soportePostal: number;
    denominacionSoportePostal: string;
    valeDestacado: string;
    estructurasComerciales: object;
    tienda: string;
    fechaCanjeo: any;
    horaCanjeo: any;
    locale: string;
    preferencia: string;
    fechaInicioCanjeo: string;
    showValeEntrega: boolean;
    tipoReclamo: string;
    canalesVisualizacion: object;
    showPopup: boolean;
  };
};
const ValeComponentActivableCanjeable: FC<Props> = ({ vale }) => {
  const { t } = useTranslation();
  const dataApp = useAppStore();
  const formatoFechaCanjeo =
    dataApp.lang === 'eu' ? 'YYYY/MM/DD' : 'DD/MM/YYYY';
  const CUPON_CANJEADO = 3;
  const CUPON_ACTIVADO = 2;
  const CUPON_NO_ACTIVADO = 1;

  if (vale.tipoLista === CUPON_NO_ACTIVADO) {
    return (
      <>
        <p>
          {t('vales.activableHasta')}
          <span className="bloque-vale__fecha">{vale.fechaFinActivacion}</span>
        </p>
      </>
    );
  }
  if (vale.tipoLista === CUPON_ACTIVADO) {
    return (
      <>
        <p>
          {t('vales.canjeableHasta')}
          <span className="bloque-vale__fecha">{vale.fechaFinCanjeoPromo}</span>
        </p>
      </>
    );
  }
  if (vale.tipoLista === CUPON_CANJEADO) {
    return (
      <>
        <p>
          {t('vales.canjeadoEl')}
          <span className="bloque-vale__fecha">
            {vale.fechaCanjeo && vale.fechaCanjeo !== ''
              ? moment((vale.fechaCanjeo as unknown) as Date).format(
                  formatoFechaCanjeo,
                )
              : '-'}
          </span>
        </p>
      </>
    );
  }
  return <></>;
};

export default ValeComponentActivableCanjeable;
